import { RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';
import { RouterStateUrl } from '../reducers/router.reducer';

/**
 * The `RouterStateSnapshot` provided by the `Router` is a large complex structure.
 * A custom RouterStateSerializer is used to parse the `RouterStateSnapshot` provided
 * by `@ngrx/router-store` to include only the desired pieces of the snapshot, the url,
 * params and queryParams.
 */
export class CustomRouterStateSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams },
    } = routerState;
    const { params } = route;

    // Only return an object including the URL, params and query params
    // instead of the entire snapshot
    return { url, params, queryParams };
  }
}
